import React from 'react';
import ProfilePic from '../images/IMG_8729.png';
import { LinkedInIcon, GitHubIcon, MailIcon, ExternalLinkIcon } from '../components/Icons';
import './WelcomePage.css';

const WelcomePage = () => {
  return (
    <div className="page-container">
      {/* Profile Header */}
      <section className="profile-header">
        <img
          src={ProfilePic}
          alt="Jared Franzone"
          className="avatar"
        />
        <div className="profile-headings">
          <h1 className="name">Jared Franzone</h1>
          <p className="role">
            Software Engineer at <strong>AWS</strong> &middot; AWS Secrets Manager
          </p>
          <p className="location">Seattle, WA</p>
        </div>
      </section>

      {/* Bio */}
      <section className="bio-section">
        <p>
          Hi there, I'm Jared.
        </p>
        <p>
          I'm a Software Engineer at <strong>Amazon Web Services (AWS)</strong> based in Seattle,
          working on the <strong>AWS Secrets Manager</strong> team.
        </p>
        <p>
          I hold a Master's Degree in Computer Science from the{' '}
          <a
            href="https://www.gatech.edu/"
            target="_blank"
            rel="noopener noreferrer"
            className="external-link"
          >
            Georgia Institute of Technology
            <ExternalLinkIcon size={12} />
          </a>{' '}
          (graduated 2025), specializing in Machine Learning. Earlier, I completed my Bachelor of Science in Computer Science at the{' '}
          <a
            href="https://illinois.edu/"
            target="_blank"
            rel="noopener noreferrer"
            className="external-link"
          >
            University of Illinois at Urbana-Champaign
            <ExternalLinkIcon size={12} />
          </a>{' '}
          in 2018.
        </p>
        <p>
          In my free time, I enjoy long-distance running, spending time with my dog, and building personal projects like{' '}
          <a
            href="https://joggr.run"
            target="_blank"
            rel="noopener noreferrer"
            className="external-link"
          >
            Joggr
            <ExternalLinkIcon size={12} />
          </a>
          , an AI running platform that generates training plans that sync directly to Garmin watches.
        </p>
      </section>

      {/* Connect Links */}
      <section className="connect-section">
        <div className="connect-buttons">
          <a
            href="https://www.linkedin.com/in/jaredfranzone/"
            target="_blank"
            rel="noopener noreferrer"
            className="connect-btn"
          >
            <LinkedInIcon size={16} />
            <span>LinkedIn</span>
          </a>

          <a
            href="https://github.com/Athena96"
            target="_blank"
            rel="noopener noreferrer"
            className="connect-btn"
          >
            <GitHubIcon size={16} />
            <span>GitHub</span>
          </a>

          <a
            href="mailto:jaredfranzone@gmail.com"
            className="connect-btn"
          >
            <MailIcon size={16} />
            <span>Email</span>
          </a>
        </div>
      </section>

      {/* Projects */}
      <section className="section-group">
        <h2 className="section-heading">Projects</h2>
        <div className="item-row">
          <div className="item-main">
            <a
              href="https://joggr.run"
              target="_blank"
              rel="noopener noreferrer"
              className="item-link"
            >
              <span className="item-title">
                Joggr <ExternalLinkIcon size={12} />
              </span>
            </a>
            <span className="item-subtitle">
              AI-generated running training plans that sync to Garmin watches
            </span>
          </div>
          <a
            href="https://joggr.run"
            target="_blank"
            rel="noopener noreferrer"
            className="item-date project-domain-link"
          >
            joggr.run
          </a>
        </div>
      </section>

      {/* Experience */}
      <section className="section-group">
        <h2 className="section-heading">Experience</h2>
        <div className="item-row">
          <div className="item-main">
            <span className="item-title">Amazon Web Services (AWS)</span>
            <span className="item-subtitle">Software Engineer &middot; AWS Secrets Manager</span>
          </div>
          <span className="item-date">Present</span>
        </div>
      </section>

      {/* Education */}
      <section className="section-group">
        <h2 className="section-heading">Education</h2>
        <div className="item-list">
          <div className="item-row">
            <div className="item-main">
              <span className="item-title">Georgia Institute of Technology</span>
              <span className="item-subtitle">M.S. in Computer Science &middot; Machine Learning</span>
            </div>
            <span className="item-date">2025</span>
          </div>

          <div className="item-row">
            <div className="item-main">
              <span className="item-title">University of Illinois at Urbana-Champaign</span>
              <span className="item-subtitle">B.S. in Computer Science</span>
            </div>
            <span className="item-date">2018</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WelcomePage;